// Phase 1 Team Members (Hardcoded)
export const phase1Team = [
  {
    Full_Name: "Max Angelo D. Perin",
    Role: "Project Leader/Fullstack Developer",
    Photo_URL: "/developers/max.jpg"
  },
  {
    Full_Name: "Imelida G. Torrefranca",
    Role: "Project Leader",
    Photo_URL: "/developers/imelda.jpg"
  },
  {
    Full_Name: "Jorge P. Cabelin jr.",
    Role: "Project Leader",
    Photo_URL: "/developers/jorge.jpg"
  },
  {
    Full_Name: "Kathlyn L. Quion",
    Role: "Project Leader",
    Photo_URL: "/developers/kathlyn.jpg"
  },
  {
    Full_Name: "Gladys R. Cabelin",
    Role: "Project Leader",
    Photo_URL: "/developers/gladys.jpg"
  },
  {
    Full_Name: "Jeomar E. Avergonzado",
    Role: "Project Leader",
    Photo_URL: "/developers/jeomar.jpg"
  },
  {
    Full_Name: "Benjie",
    Role: "Assistant Developer",
    Photo_URL: "/developers/benjie.jpg"
  }
];

// Phase 3 Team Members (Hardcoded)
export const phase3Team = [
  {
    Full_Name: "Jeffrey Peresores",
    Role: "Proj Leader/Fullstack Dev",
    Photo_URL: "/developers/jeff.png"
  },
  {
    Full_Name: "Jade Madijanon",
    Role: "UI/UX Designer",
    Photo_URL: "/developers/jade.jpg"
  },
  {
    Full_Name: "Danica Cardaña",
    Role: "Data Analyst",
    Photo_URL: "/developers/danica.png"
  },
   {
    Full_Name: "James Ronolo",
    Role: "Backend Developer",
    Photo_URL: "/developers/james.png"
  },
  {
    Full_Name: "John Geraldez",
    Role: "Backend Developer",
    Photo_URL: "/developers/john.png"
  },
   {
    Full_Name: "Ket Guenefer Jaya",
    Role: "Database",
    Photo_URL: "/developers/ket.png"
  },
  {
    Full_Name: "Regie Bago Gelsano",
    Role: "Database",
    Photo_URL: "/developers/regie.png"
  },
  {
    Full_Name: "Max Angelo Perin",
    Role: "Project Adviser",
    Photo_URL: "/developers/max.jpg"
  },
  {
    Full_Name: "Imelida G. Torrefranca",
    Role: "Project Leader",
    Photo_URL: "/developers/imelda.jpg"
  },
  {
    Full_Name: "Jorge P. Cabelin jr.",
    Role: "Project Leader",
    Photo_URL: "/developers/jorge.jpg"
  },
  {
    Full_Name: "Kathlyn L. Quion",
    Role: "Project Leader",
    Photo_URL: "/developers/kathlyn.jpg"
  },
  {
    Full_Name: "Gladys R. Cabelin",
    Role: "Project Leader",
    Photo_URL: "/developers/gladys.jpg"
  },
  {
    Full_Name: "Jeomar E. Avergonzado",
    Role: "Project Leader",
    Photo_URL: "/developers/jeomar.jpg"
  }
];
